"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./google-chart/google-chart.component"));
var google_charts_module_1 = require("./google-charts.module");
exports.Ng2GoogleChartsModule = google_charts_module_1.Ng2GoogleChartsModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-google-charts/index.js
// module id = 263
// module chunks = 13